<template>
  <div
    class="change-password-view"
    @keyup.enter="onEnterPressed"
  >
    <div class="floating-card">
      <h1 class="card-text">
        Change Your Password
      </h1>
      <TextInput
        v-model="currentPassword"
        label="Current Password"
        type="password"
        :required="true"
      />
      <TextInput
        v-model="newPassword"
        label="New Password"
        type="password"
        :required="true"
      />
      <div
        v-show="showErrorMessage"
        class="error-text"
      >
        {{ errorMessage }}
      </div>
      <div class="button-wrapper">
        <LockingButton
          class="locking-button"
          :disabled="!formValid"
          :locked="loading"
          :text="'Change'"
          @click="changePassword"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import TextInput from '@/components/shared/TextInput.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'
import { ChangePasswordMessage } from '@/@types/messages/ChangePasswordMessage'
import Toaster from '@meforma/vue-toaster'
import LockingButton from '@/components/shared/LockingButton.vue'
import { ErrorsResponse } from '@/@types/responses/common/ErrorsResponse'

export default defineComponent({
  name: 'ChangePassword',
  components: {
    TextInput,
    LockingButton
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    const toast = inject(PROVIDER_CONSTANTS.toaster) as Toaster

    return {
      miscellaneousService,
      toast
    }
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      loading: false,
      showErrorMessage: false,
      errorMessage: ''
    }
  },
  computed: {
    formValid(): boolean {
      return this.currentPassword.trim() !== '' && this.newPassword.trim() !== ''
    }
  },
  methods: {
    changePassword(): void {
      if (this.loading) return

      this.showErrorMessage = false
      this.loading = true

      const changePasswordMessage = new ChangePasswordMessage(this.currentPassword, this.newPassword)
      this.miscellaneousService.changePassword(changePasswordMessage).then(() => {
        this.loading = false
        this.toast.success('Password changed successfully.')
        this.$router.push('/')
      }).catch(error => {
        const errorsResponse = error as ErrorsResponse

        this.loading = false
        this.errorMessage = errorsResponse.errors.map(e => e.message).join("\r\n")
        this.showErrorMessage = true
      })
    },
    onEnterPressed(): void {
      if (this.formValid)
        this.changePassword()
    }
  }
})
</script>

<style scoped lang="scss">

.change-password-view {
  @include sac-floating-card-view;
}

</style>
